import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OutlinePreviewRoutingModule } from './outline-preview-routing.module';
import { OutlinePreviewComponent } from './outline-preview.component';
import { DxScrollViewModule } from 'devextreme-angular';
import { I18nModule } from 'app/shared/i18n/i18n.module';
import { PDFModule } from 'app/pdf/pdf.module';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  imports: [
    CommonModule,
    OutlinePreviewRoutingModule,
    I18nModule,
    DxScrollViewModule,
    PDFModule,
    FormsModule,
    NgxSpinnerModule
  ],
  declarations: [
    OutlinePreviewComponent
  ],
})
export class OutlinePreviewModule { }
